import AbstractBlock from './abstractBlock.js';
import CitySelect from './enterInfo/city.js';
import AreaSelect from './enterInfo/area.js';
import StreetSelect from './enterInfo/street.js';
import HouseSelect from './enterInfo/house.js';
import config from './../config.js';

/**
 * Результирующая дата о форме
 */
class FullData {
    constructor(data = {}) {
        this.full_address = data.full_address;
        this.city_id = data.city_id;
        this.city = data.city;
        this.street = data.street;
        this.street_id = data.street_id;
        this.house = data.house;
        this.house_id = data.house_id;
        this.coordinates = data.coordinates;
        this.geoObject = data.geoObject;
    }
}

export default class InsertInfoBlock extends AbstractBlock {
    constructor(opts = {}, events = {}) {
        super(opts, events);

        this.citySelect = new CitySelect(
            {
                citys: this.opts.citys || [],
            },
            {
                select: (id) => {
                    if (id) {
                        this.streetSelect.city = id;
                        this.areaSelect.load(id);
                    } else {
                        this.streetSelect.drop();
                        this.areaSelect.clear();
                    }
                },
                drop: () => {
                    this.streetSelect.drop();
                    this.areaSelect.clear();
                },
            }
        );
        this.areaSelect = new AreaSelect(
            {
                areas: this.opts.areas || [],
            },
            {
                select: (id) => {
                    if (id && id !== config.defaultArea.id) {
                        this.streetSelect.city = id;
                    } else {
                        this.streetSelect.city = this.cityId;
                    }
                },
                drop: () => {
                    this.streetSelect.drop();
                    this.streetSelect.city = this.cityId;
                },
                beforeload: () => {
                    if (!this.city) {
                        this.areaSelect.hintMessage = 'Город не выбран';

                        return false;
                    }
                },
            }
        );
        this.streetSelect = new StreetSelect(
            {},
            {
                select: (id) => {
                    if (id) {
                        this.houseSelect.street = id;
                    }
                },
                drop: () => {
                    this.houseSelect.drop();
                },
                beforeload: () => {
                    if (!this.area) {
                        this.streetSelect.hintMessage = 'Район не выбран';

                        return false;
                    }
                },
            }
        );
        this.houseSelect = new HouseSelect(
            {},
            {
                accept: ::this.confirm,
            }
        );
    }

    /**
     * Инициализируем поведение
     *
     * @param {jquery} element
     */
    init(element) {
        this.element = element.find('.js-enter_info_form');

        if (this.hasElement) {
            console.log('Insert Info Block inited');
        } else {
            throw new Error('Insert Info Block no element');
        }

        this.citySelect.init({
            element: this.element.find('.js-enter_info_form__city'),
            error: this.element.find('.js-enter_info_form__city_error'),
        });
        this.areaSelect.init({
            element: this.element.find('.js-enter_info_form__area'),
            error: this.element.find('.js-enter_info_form__area_error'),
        });
        this.streetSelect.init({
            element: this.element.find('.js-enter_info_form__street'),
            error: this.element.find('.js-enter_info_form__street_error'),
        });
        this.houseSelect.init({
            element: this.element.find('.js-enter_info_form__house'),
            error: this.element.find('.js-enter_info_form__house_error'),
        });

        this.element
            .on('click', '.js-enter_info_form__confirm', ::this.confirm)
            .on(
                'click',
                '.js-enter_info_form__house_not_found',
                ::this.houseNotFound
            );

        this.citySelect.select(config.citys.find((city) => city.selected));
    }

    /**
     * Получить значение города (название)
     *
     * @return {String} cityName
     */
    get city() {
        return this.citySelect.val;
    }

    /**
     * Получить ID выбранного города
     *
     * @return {Number} cityId
     */
    get cityId() {
        var data = this.citySelect.data;
        var id = data.id;

        if (!id) {
            return null;
        }

        return parseInt(id, 10);
    }

    /**
     * Получить название улицы
     *
     * @return {String} streetName
     */
    get street() {
        var data = this.streetSelect.data;
        var name;
        var socr;

        if (!data) {
            return '';
        }

        name = data.name || '';
        socr = data.socr || '';

        if (!data || !name) {
            return '';
        }

        return `${socr} ${name}`;
    }

    get area() {
        const {
            data: { id },
        } = this.areaSelect;

        if (!id) {
            return null;
        }

        return parseInt(id, 10);
    }

    /**
     * Получить ID улицы введенной в форме
     *
     * @return {Number} streetId
     */
    get streetId() {
        var data = this.streetSelect.data;
        var id = data.id;

        if (!id) {
            return null;
        }

        return parseInt(id, 10);
    }

    /**
     * Получить значение дома
     *
     * @return {String} houseName
     */
    get house() {
        return this.houseSelect.val || '';
    }

    /**
     * Получить строку с полным введенным адресом
     *
     * @return {String} fullAdress "Город Улица Дом"
     */
    get fullAdress() {
        return `${this.city}, ${this.street}, дом ${this.house}`;
    }

    /**
     * Получить полную информацию о форме
     *
     * @return {FullData} fullData
     */
    get fullData() {
        const cityId =
            this.area || this.area !== config.defaultArea.id
                ? this.area
                : this.cityId;

        return new FullData({
            full_address: this.fullAdress,
            city_id: cityId,
            city: this.city,
            street: this.street,
            street_id: this.streetId,
            house: this.houseSelect.name,
            house_id: this.houseSelect.id,
            geoObject: this.houseSelect.geoObject,
            coordinates: this.houseSelect.coordinates,
        });
    }

    /**
     * Проверить все блоки на корректность перед отправкой
     *
     * @return {Boolean} isValid Все ли блоки прошли проверку
     */
    validate() {
        let isValid = true;

        if (!this.house) {
            this.houseSelect.error = 'Введите номер дома';
            isValid = false;
        }

        if (!this.street) {
            this.streetSelect.error = 'Выберите улицу';
            isValid = false;
        }

        if (!this.area) {
            this.areaSelect.error = 'Выберите район';
            isValid = false;
        }

        if (!this.city) {
            this.citySelect.error = 'Выберите город';
            isValid = false;
        }

        return isValid;
    }

    /**
     * Завершить работу с блоком
     */
    confirm() {
        if (!this.validate()) {
            return;
        }

        this.events.trigger('confirm');
    }

    /**
     * Вызываем событие для случая когда пользователь не нашел свой дом
     */
    houseNotFound() {
        this.events.trigger('houseNotFound');
    }

    /**
     * Отобразить общую ошибку
     * Например при ошибке сохранения
     *
     * @param {String} error
     *
     * @return {InsertInfoBlock} self
     */
    displayError(error) {
        if (!error) {
            this.houseSelect.error = false;
            return this;
        }

        this.houseSelect.error = error;

        return this;
    }
}
